import { useInstallerContext } from '../context/InstallerContext';
import { getInstallLink } from '../services/apis';
import { getVersionToInstall } from '../selectors/appForInstallation';
import { usePanorama } from '../context/PanoramaContext';
export const useProvisionApis = () => {
  const {
    appId,
    httpClient,
    version,
    shareUrlId,
    versionOverrideId,
    preInstallationData: {
      appForInstallation,
      authorizationHeader
    }
  } = useInstallerContext();
  const {
    startTransaction,
    finishTransaction
  } = usePanorama();
  const requestOptions = authorizationHeader ? {
    headers: {
      authorization: authorizationHeader
    }
  } : undefined;
  const shouldAddOverrideId = version === 'dev' && versionOverrideId;
  const installWithShareUrlId = async oauth2 => {
    startTransaction('install-from-share-url', {
      ...(shareUrlId && {
        shareUrlId
      }),
      ...(versionOverrideId && {
        versionOverrideId
      })
    });
    const payload = {
      shareUrlId,
      oauth2,
      ...(shouldAddOverrideId && {
        devVersion: {
          overrideId: versionOverrideId
        }
      })
    };
    const response = await httpClient.post(getInstallLink({
      isShareUrl: true
    }), payload, requestOptions);
    finishTransaction('install-from-share-url', {
      requestId: response.requestId
    });
    return response;
  };
  const installWithAppId = async oauth2 => {
    startTransaction('bulk-install', {
      version
    });
    const payload = {
      apps: [{
        id: appId,
        version: getVersionToInstall(appForInstallation, version),
        oauth2,
        ...(shouldAddOverrideId && {
          // todo sled test when create dev sites is fixed
          devVersion: {
            overrideId: versionOverrideId
          }
        })
      }]
    };
    const response = await httpClient.post(getInstallLink(), payload, requestOptions);
    finishTransaction('bulk-install', {
      requestId: response.requestId
    });
    return response;
  };
  return {
    installWithAppId,
    installWithShareUrlId
  };
};
//# sourceMappingURL=useProvisionApis.js.map